export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const getTotals = companies => {
  let totalCount = 0
  let totalValue = 0
  Object.keys(companies).forEach(companyName => {
    const company = companies[companyName]
    totalCount += company.count
    totalValue += company.totalValue
  })

  return {
    totalCount,
    totalValue
  }
}
